/*
 * SkillzSDK-iOS
 *
 * Created by Tj Fallon on 4/26/16.
 *
 * @providesModule InsufficientFunds
 *
 */

import React from 'react';

import {_m} from 'INTL';
import AWSManager from 'AWSManager';
import FTUEStyles from 'FTUEStyles';
import Label from 'Label';
import LTOComponent from 'LTOComponent';
import PropTypes from 'prop-types';
import SkillzImage from 'SkillzImage';
import SkillzStyle from 'SkillzStyle';
import styles from 'InsufficientFundsStyles';

import {NativeModules, TouchableWithoutFeedback, View} from 'react-native';

const SKZDepositManager = NativeModules.SKZDepositManager;

export default class InsufficientFunds extends React.Component {
  constructor() {
    super();

    this.state = {};
  }

  static propTypes = {
    mainNavigator: PropTypes.any,
    onDone: PropTypes.func,
    isCash: PropTypes.bool,
  };

  componentDidMount() {
    console.debug('mount InsufficientFunds');
  }

  componentWillUnmount() {
    console.debug('unmounting InsufficientFunds');
  }

  _dismissModal() {
    console.debug('Dismiss modal in InsufficientFunds');
    if (this.props.onDone) {
      this.props.onDone();
    }
  }

  _claimOffer() {
    const storeInfo = this.state.storeInfo;
    SKZDepositManager.processDepositOffer(
      storeInfo.limited_time_offer,
      storeInfo.payment_types,
      storeInfo.apple_pay,
      storeInfo.paypal,
      storeInfo.stored_card,
      null
    );
  }

  _renderOutOfFundsCopy(): React.ReactNode {
    let message = '';
    let id = '';
    if (this.props.isCash) {
      message = 'Add Funds';
      id = 'add_funds';
    } else {
      message = 'Out of Funds';
      id = 'out_of_funds';
    }
    return (
      <View style={styles.header} accessible={true} accessibilityLabel={id}>
        <Label style={styles.headerText}>{_m(message)}</Label>
        <Label style={styles.detailText} numberOfLines={2}>
          {this.props.isCash
            ? _m('Increase your balance to play this match')
            : _m("You don't have enough funds to enter this match.")}
        </Label>
      </View>
    );
  }

  _renderCloseButton(): React.ReactNode {
    return (
      <TouchableWithoutFeedback
        onPress={() => {
          this._dismissModal();
        }}
      >
        <SkillzImage
          style={styles.closeButton}
          resizeMode={'contain'}
          source={'btn_close_solid_gray_skz.png'}
          color={SkillzStyle.fullStyles.textColorSecondary.color}
        />
      </TouchableWithoutFeedback>
    );
  }

  _renderContent(): React.ReactNode {
    return (
      <View style={{alignItems: 'center', padding: 16, backgroundColor: 'transparent'}}>
        {this._renderOutOfFundsCopy()}
        <LTOComponent
          isInsufficientFunds={true}
          mainNavigator={this.props.mainNavigator}
          isCash={this.props.isCash}
          onDone={this.props.onDone}
          isStoreDisplayed={true}
        />
        {this._renderCloseButton()}
      </View>
    );
  }

  render(): React.ReactNode {
    return (
      <TouchableWithoutFeedback
        style={FTUEStyles.fullScreenContainer}
        onPress={() => {
          this._dismissModal();
        }}
        accessible={false}
      >
        <View style={[FTUEStyles.dropShadowContainer, styles.centerDialog]} accessible={false}>
          <View style={styles.contentBox}>
            <TouchableWithoutFeedback style={styles.contentBox} accessible={false}>
              {this._renderContent()}
            </TouchableWithoutFeedback>
          </View>
        </View>
      </TouchableWithoutFeedback>
    );
  }
}
